import { Reveal } from "@/components/Reveal";

const chapters = [
  {
    no: "01",
    title: "Quality & Governance",
    body: "High-quality diagnostic acquisition and reporting, appropriate clinical governance, quality assurance, and clear escalation pathways for significant findings — agreed before any service begins.",
  },
  {
    no: "02",
    title: "Flexible Delivery",
    body: "Regular clinics or individual diagnostic sessions, configured around your clinical pathway, local demand and governance arrangements — with equipment and specialist expertise provided.",
  },
  {
    no: "03",
    title: "Focused Expertise",
    body: "A focused specialist service rather than a large-volume diagnostic organisation — led by a Consultant Cardiac Physiologist with two decades of cardiovascular imaging experience.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="bg-ivory py-28 lg:py-36" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">
          The CVI Charter
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-navy max-w-2xl leading-tight">
          Quality at the centre of every study we deliver.
        </h2>
      </Reveal>

      <div className="mt-20 grid md:grid-cols-3 gap-px bg-navy/10 border border-navy/10">
        {chapters.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.12} className="bg-ivory">
            <div
              className="p-10 lg:p-12 h-full group hover:bg-navy transition-colors duration-500"
              data-testid={`manifesto-chapter-${c.no}`}
            >
              <p className="font-mono text-xs tracking-[0.3em] text-gold mb-10">{c.no} /</p>
              <h3 className="font-serif text-2xl font-semibold text-navy group-hover:text-ivory transition-colors duration-500 mb-5">
                {c.title}
              </h3>
              <p className="text-sm leading-relaxed text-navy/60 group-hover:text-ivory/70 transition-colors duration-500">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
